import { axios, base } from '../http';

export const getStudentUpgradeRules = (schId) => {
  return axios.get(`${base}/api/StudentUpgrade/GetRules`, {
    params: { schId }
  });
};

export const saveStudentUpgradeRules = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/SaveRules`, params);
};

export const batchUpdateClassBigType = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/BatchUpdateClassBigType`, params);
};

export const previewAnnualUpgrade = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/PreviewAnnualUpgrade`, params);
};

export const executeAnnualUpgrade = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/ExecuteAnnualUpgrade`, params);
};

/** 单班结转预演（升班改名 / 毕业归档） */
export const previewClassTransfer = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/PreviewClassTransfer`, params);
};

/** 按预演确认执行单班结转 */
export const executeClassTransfer = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/ExecuteClassTransfer`, params);
};

/** 整年级结转预演（该年级下全部班级） */
export const previewGradeTransfer = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/PreviewGradeTransfer`, params);
};

/** 按预演确认执行整年级结转 */
export const executeGradeTransfer = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/ExecuteGradeTransfer`, params);
};

export const getStudentUpgradeBatchPage = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/GetBatchPage`, params);
};

export const getStudentUpgradeBatchDetails = (batchId, schId) => {
  return axios.get(`${base}/api/StudentUpgrade/GetBatchDetails`, {
    params: { batchId, schId }
  });
};

/** 分页获取升班结转批次学生快照 */
export const getStudentUpgradeBatchStudentDetails = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/GetBatchStudentDetails`, params);
};

/** 删除升班结转批次（解除同学年锁定，不回滚业务数据） */
export const deleteStudentUpgradeBatch = (params) => {
  return axios.post(`${base}/api/StudentUpgrade/DeleteBatch`, params);
};
